import axios from 'axios';
import React, { useEffect, useState } from 'react';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

export interface CountrySummary {
  name: string;
  iso: string;
  [key: string]: unknown;
}

interface CountryByIsoResponse {
  name: string;
}

interface CountryByNameResponse {
  iso: string;
}

interface MaterialIconProps extends React.HTMLAttributes<HTMLSpanElement> {
  iconName: string;
}

export function FetchCountryName(countryIso: string): Promise<string> {
  //is used in other js scripts
  return axios
    .get<CountryByIsoResponse>(`${backendUrl}/worlddata/countries/iso/${countryIso}`)
    .then((response) => {
      return response.data.name ?? '';
    })
    .catch((error) => {
      console.error('Error fetching country data by iso', error);
      return '';
    });
}

export async function FetchAllCountries(): Promise<CountrySummary[]> {
  try {
    const response = await axios.get<CountrySummary[]>(`${backendUrl}/worlddata/countries/all/`);
    return response.data; // array of { name, iso, ... }
  } catch (error) {
    console.error('Error fetching all countries:', error);
    return [];
  }
}

export function FetchCountryIso(countryName: string): Promise<string | undefined> {
  //is used in other js scripts
  return axios
    .get<CountryByNameResponse>(`${backendUrl}/worlddata/countries/${countryName}`)
    .then((response) => {
      return response.data.iso;
    })
    .catch((error) => {
      console.error('Error fetching iso data by country name', error);
      return undefined;
    });
}

export const ParseCoordinates = (coordinateString: string): [number, number] => {
  const coordinatePattern = /(\d+)°(\d+)'(\d+\.\d+)"([NS])\s*[-\s]*([-\d]+)°(\d+)'(\d+\.\d+)"([EW])/;
  const match = coordinateString.match(coordinatePattern);
  if (!match) {
    console.debug('No coordinate string for this post:', coordinateString);
    return [NaN, NaN];
  }
  const [, latDeg, latMin, latSec, latDir, lonDeg, lonMin, lonSec, lonDir] = match;

  const lat = (parseFloat(latDeg) + parseFloat(latMin) / 60 + parseFloat(latSec) / 3600) * (latDir === 'N' ? 1 : -1);
  const lon = (parseFloat(lonDeg) + parseFloat(lonMin) / 60 + parseFloat(lonSec) / 3600) * (lonDir === 'E' ? 1 : -1);
  return [lat, lon];
};

export function MaterialIcon({ iconName, style = {}, className = 'material-icons', ...props }: MaterialIconProps): JSX.Element {
  const [fontReady, setFontReady] = useState(false);

  useEffect(() => {
    if (document.fonts) {
      document.fonts.ready.then(() => setFontReady(true));
    } else {
      setFontReady(true); // fallback for older browsers
    }
  }, []);

  return (
    <span className={className} style={style} {...props}>
      {' '}
      {fontReady ? iconName : ''}{' '}
    </span>
  );
}

export default MaterialIcon;
